import { loadTemplate } from "utils/load_template"
import SelectRefinementWidget from 'components/algolia/select_refinement_widget'
import DistinctRefinementWidget from 'components/algolia/distinct_refinement_widget'

export function presentersWidget({ showCounters }) {
  if (showCounters) {
    return new DistinctRefinementWidget({
      connector: instantsearch.connectors.connectRefinementList,
      showCounters: showCounters,
      facetCounterAttribute: "presenters"
    }).widget({
      attribute: "presenters",
      operator: "or",
      limit: 100,
      container: "presenters",
      transformItems(items) {
        return items.map(item => ({
          ...item,
          label: item.label.split('||')[1],
          image: item.label.split('||')[0]
        })).filter(item => item.label)
      },
      searchable: true,
      searchablePlaceholder: "Type a name",
      searchableIsAlwaysActive: true,
      templates: { item: loadTemplate("cle_presenters_filter_template_with_counters") },
      cssClasses: {
        root: "scrollable"
      },
      sortBy: ["isRefined", "name:asc"]
    })
  } else {
    return instantsearch.widgets.refinementList({
      container: '#presenters',
      attribute: 'presenters',
      operator: 'and',
      transformItems(items) {
        return items.map(item => ({
          ...item,
          label: item.label.split('||')[1],
          image: item.label.split('||')[0]
        })).filter(item => item.label)
      },
      searchable: true,
      searchablePlaceholder: "Type a name",
      searchableIsAlwaysActive: true,
      templates: { item: loadTemplate("cle_presenters_filter_template") },
      cssClasses: {
        root: "scrollable"
      },
      sortBy: ["isRefined", "name:asc"]
    })
  }
}

export function presentersMobileWidget() {
  return new SelectRefinementWidget({ selectType: "single" }).widget({
    attribute: "presenters",
    limit: 500,
    container: "presenter_mobile",
    cssClasses: {
      item: "presenter-filter-item"
    },
    transformItems: (items) => {
      return items.map(item => ({
        ...item,
        label: loadTemplate("cle_presenters_filter_mobile_template").interpolateObject({
          label: item.label.split('||')[1],
          image: item.label.split('||')[0]
        })
      }))
    },
    sortBy: ["isRefined", "name:asc"]
  })
}
